import axiosClient from './axiosClient';

// Consulta de RUC/DNI (Decolecta) para autocompletar nombre/direccion del cliente al
// emitir una factura (ver OrderDetailDialog).
const documentLookupApi = {
  lookup: (type, number) => axiosClient.get(`/document-lookup/${type}/${number}`),
};

export default documentLookupApi;
